import { useFormikContext } from "formik";
import { useEffect, useMemo } from "react";
import { v4 as uuidv4 } from "uuid";

type UseFormikAutoFieldNameProps = {
  enabled: boolean;
  fieldName?: string;
  items?: { type: string; name?: string }[];
};

export const useFormikAutoFieldName = ({
  enabled,
  fieldName = "name",
  items
}: UseFormikAutoFieldNameProps) => {
  const { values, setFieldValue } = useFormikContext<Record<string, unknown>>();
  const randomString = useMemo(() => {
    return uuidv4().split("-")[0];
  }, []);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    if (!items) {
      setFieldValue(fieldName, `vm-${randomString}`);
      return;
    }

    const namedParts = (items ?? [])
      .map(({ name }) => name)
      .filter((name): name is string => Boolean(name));

    setFieldValue(
      fieldName,
      namedParts.length > 0 ? [...namedParts, randomString].join(" - ") : `vm-${randomString}`
    );
  }, [enabled, items, fieldName, values, setFieldValue, randomString]);
};
